export { decorateMember } from './decorateMember';
export { decorateProduct } from './decorateProduct';
export { decorateRecipe, decorateRecipes } from './decorateRecipes';
export { decorateWorkout, decorateWorkoutSteps } from './decorateWorkout';



// WEBPACK FOOTER //
// ./src/decorators/index.js